module.exports = __webpack_public_path__ + "static/media/repara.e040e027.png";